import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  ResponseOptions,
  ResponseActions,
  ResponseComments,
  CommentsHeader,
  ActionResponseButton,
  Label,
} from "./actionResponseStyles.js";
import { LabeledRadioButton } from "../../reusableComponents/LabeledRadioButton/index.js";

const ActionResponseForm = ({ handleUserSubmit }) => {
  const [vendorResponse, setVendorResponse] = useState("approved");
  const [vendorComments, setVendorComments] = useState("");
  const handleOptionChange = (evt) => setVendorResponse(evt.target.value);

  return (
    <>
      <ResponseOptions>
        <LabeledRadioButton
          id="approved"
          handleOptionChange={handleOptionChange}
          currentSelectedOption={vendorResponse}
          label="Approve Request"
          btnSize="large"
          optionsGroup="vendorOptions"
        />
        <LabeledRadioButton
          id="request-edits"
          handleOptionChange={handleOptionChange}
          currentSelectedOption={vendorResponse}
          label="Request Edits"
          btnSize="large"
          optionsGroup="vendorOptions"
        />
      </ResponseOptions>
      <ResponseComments>
        <CommentsHeader>
          <Label htmlFor="vendor-comments">Comments</Label>
          <div style={{ color: "#666" }}>
            {400 - vendorComments.length} character(s) left
          </div>
        </CommentsHeader>

        <textarea
          id="vendor-comments"
          rows="5"
          cols="15"
          value={vendorComments}
          onChange={(evt) => setVendorComments(evt.target.value)}
          style={{ resize: "none" }}
          maxLength={400}
        ></textarea>
      </ResponseComments>
      <ResponseActions>
        <ActionResponseButton
          label="Submit"
          clickHandler={() => handleUserSubmit(vendorResponse, vendorComments)}
        />
      </ResponseActions>
    </>
  );
};

ActionResponseForm.propTypes = {
  handleUserSubmit: PropTypes.func.isRequired,
};

export default ActionResponseForm;
